import { doRequest } from "utils/core";

const paymentAPI = {
  getPaymentList: (params) => {
    const url = "api/payment/list";
    return doRequest("get", url, { params });
  },
  getPaymentByDate: (params) => {
    const url = "api/payment/payment_info";
    return doRequest("get", url, { params });
  },
};

export default paymentAPI;
